import config from "console_config";

interface BufferedEvent {
  name: string;
  payload: Record<string, unknown>;
}

const MAX_BUFFER_SIZE = 50;
const BUFFER_TTL_MS = 5 * 60 * 1000; // 5 minutes
const POLL_INTERVAL_MS = 500;

let buffer: BufferedEvent[] = [];
let pollTimer: ReturnType<typeof setInterval> | null = null;
let bufferStartTime: number | null = null;

const hasPendoConfig = (): boolean =>
  Boolean(config.ID_PENDO || config.ID_PENDO_AUTH);

const stopPolling = (): void => {
  if (pollTimer !== null) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
};

export const clearBuffer = (): void => {
  buffer = [];
  bufferStartTime = null;
  stopPolling();
};

export const getBufferSize = (): number => buffer.length;

export const flushBuffer = (): void => {
  if (!window.pendo) return;

  for (const event of buffer) {
    try {
      window.pendo.track(event.name, event.payload);
    } catch {
      // Don't let a single failed event block the rest
    }
  }

  clearBuffer();
};

const startPolling = (): void => {
  if (pollTimer !== null) return;

  pollTimer = setInterval(() => {
    if (window.pendo) {
      flushBuffer();
      return;
    }

    if (
      bufferStartTime !== null &&
      Date.now() - bufferStartTime >= BUFFER_TTL_MS
    ) {
      clearBuffer();
    }
  }, POLL_INTERVAL_MS);
};

export const bufferEvent = (
  name: string,
  payload: Record<string, unknown>
): void => {
  if (!hasPendoConfig()) return;

  if (bufferStartTime === null) {
    bufferStartTime = Date.now();
  }

  // Drop oldest event if at capacity
  if (buffer.length >= MAX_BUFFER_SIZE) {
    buffer.shift();
  }

  buffer.push({ name, payload });

  startPolling();
};
